import { useAFormHandler } from 'analytics/hooks'
import { useFormik } from 'formik'
import { Company, CompanyAddDTO, Prepayment } from 'modules/domain/company/types'
import { endpoints } from 'modules/endpoints'
import { apiClient } from 'modules/utils/httpClient'
import { FC } from 'react'
import { CompanyRuDetailsModal } from './CompanyRuDetailsModal'

type Props = {
  refreshCompanies: (silent: boolean) => void
  onClose: () => void
}

export const CompanyRuAdd: FC<Props> = ({ onClose, refreshCompanies }) => {
  const { formProgress, formHandler } = useAFormHandler()

  const formik = useFormik<CompanyAddDTO>({
    initialValues: {
      inn: '',
      name: '',
      prepayment: Prepayment.unknown,
      payment_delay_days: 0,
      vat: false,
      company_size: null,
      //companies_group_name: '',
    },
    enableReinitialize: true,
    onSubmit: formHandler(async () => await apiClient.post<Company>(endpoints.company(), formik.values), {
      onSuccess: async () => {
        await refreshCompanies(true)
        onClose()
      },
      onError: (error) => {
        const { errors } = error
        formik.setErrors(errors)
      },
    }),
  })

  return <CompanyRuDetailsModal progress={formProgress} onClose={onClose} formik={formik} isAdd />
}
